module.exports = __webpack_public_path__ + "static/flowers-c063ccd193b528132a772ea9fa90dafb.png";